module.exports = __webpack_public_path__ + "img/full-logo.9e7d3420.svg";